import { Location } from 'vue-router'
import { Roadmap } from '@/typings/api/Roadmap'

import { dateFormatter } from '@/helpers/dateFormatter'
import { createEdit, createView, DELETE } from '@/helpers/enums/table-actions'
import { ROADMAPS_ROUTES as ROUTES } from './utils'


const getEditRoute = (data: Roadmap): Location => ({
  name: ROUTES.EDIT,
  params: { id: data.id.toString() },
})

const getViewRoute = (data: Roadmap): Location => ({
  name: ROUTES.VIEW,
  params: { id: data.id.toString() },
})

export const TABLE_ACTIONS = Object.freeze([
  createEdit<Roadmap>(getEditRoute),
  createView<Roadmap>(getViewRoute),
  DELETE,
])


export const TABLE_HEADERS = Object.freeze([
  {
    text: 'Название',
    value: 'name',
    sortable: false,
    width: 180,
    getRoute: getViewRoute,
  },
  /*
  {
    text: 'Описание',
    value: 'description',
    sortable: false,
    field: (value: Roadmap['description']): string => {
      if (value?.length > 123) {
        return value.slice(0, 120)
      }

      return value
    },
  },
  */
  {
    text: 'Список кодов АТЕ',
    value: 'ates',
    sortable: false,
    field: (_: void, value: Roadmap) => value,
  },
  {
    text: 'Опубликована?',
    value: 'is_published',
    sortable: false,
  },
  {
    text: 'Обновлена?',
    value: 'is_updated',
    sortable: false,
  },
  {
    text: 'Дата изменения',
    value: 'updated_at',
    sortable: true,
    width: 130,
    field: (value: Roadmap['updated_at']) => (
      value && dateFormatter(value)
    ),
  },
])
